import { render } from "./CloseButton.vue?vue&type=template&id=6e45a146&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=6e45a146&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e45a146"],['__file',"src/components/button/CloseButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e45a146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e45a146', __exports__)) {
    console.log('reload')
    api.reload('6e45a146', __exports__)
  }
  
  module.hot.accept("./CloseButton.vue?vue&type=template&id=6e45a146&scoped=true", () => {
    console.log('re-render')
    api.rerender('6e45a146', render)
  })

}


export default __exports__